
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { decrypt } from './utilities/utilityFunctions';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
    public myRoute: Router,
    private location: Location
  ) {}

  canActivate(): boolean {
    if (!(localStorage.getItem('esp-profile-details'))) {
      return true;
    } else {     
      let d = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));
        if(d.profileId){
          this.myRoute.navigate(['/dashboard'])
        return false;
      }
    }
    return true
  }

}
